import { Box } from "@mui/material";
import React from "react";
import {
  Buttons,
  DrawerCTA,
  Gallery,
  Highlights,
  Price,
  TopDrawer,
  useActiveUnit,
} from ".";
import { useUnitHighlight } from "./hooks";
import OpenHouse from "./OpenHouse";
import { getFocus, useAtom, useGet } from "state/jotai";
import { get, label } from "components/Favorites/Favorites.Utilities";
// import { drawer_animation_done } from "state/store.global";
import { _drawer, active_project, drawer_animation_done} from 'state/store.global'
import { PoweredBy } from "components/PoweredBy/PoweredBy";
import ReservationButton from "./ReservationButton";
import DropdownProperties from "./DropdownProperties";
import { useBreak } from "hooks/useBreak";
import { Scrollbar } from "react-scrollbars-custom";
import { useLocation } from "react-router-dom";
import { _bootstrap } from "state/store.bootstrap";
import NewReservationButton from "./NewReservationButton";
import { getProjectData } from "state/jotai.projectDataHooks";
import { useFetch_Units } from "hooks/fetch/useFetch_Units";


function UnitDrawer() {
  const here = useLocation().pathname;
  const { pin, pid }         = useGet(active_project);
  const unit = useActiveUnit();
   const projectIDis = unit?.data?.ProjectID;
   
  const type                = useGet(_bootstrap).type
  const highlights = useUnitHighlight(unit);

  //  const units      = getProjectData('units', 'Units');
    const poly = type === 'poly'
   const uni = useFetch_Units({ pid:poly?pid:null, pin:poly?pin:null }).D
   

   const customFacilities = uni?.customFacility ?? [];
   
// console.log(customFacilities, 'customFacilities');
const facilitiesForCurrentProject = customFacilities.filter(f => f.ProjectID == projectIDis);
// console.log(facilitiesForCurrentProject,"drWER")
  const unitId = parseInt(unit.getId());
  const status = unit.getStatus();
  const address = unit.getAddress();
  const moveindate = unit.getMoveInDate();  
  const townAndZipcode = unit.getTownZipCode();
  const topicCode = unit?.data?.Data?.Egen_emne_kode?.Value

  const isRent = unit.isRent();
  const price = unit.getPrice();
  const Pris = unit.getPris();

  const properties = unit.getProperties();
  
  const availableUnits = unit?.data?.Data?.UnitStatusID?.Value === 10;
  const availablePris = unit?.data?.Data?.Pris_Tekst_DK?.Value === "";
//  console.log(properties,"djjdjd")
//  const filteredProperties = availablePris
//   ? properties.filter(property => property.data && property.data.length > 1 && (property.order !== 40 || property.data.some(item => item.Value !== false)))
//   : properties.filter(property => property.order !== 20 && property.data && property.data.length > 1 && (property.order !== 40 || property.data.some(item => item.Value !== false)));
  
  const filteredProperties = properties.filter(property =>
  property.data?.some(item => item?.Value !== false && item?.Value !== "")
);


  const filterHighlights = highlights.filter((highlight, i) => {
   
    if(highlight?.value)
      return true
  });
  
  const isDrawerAnimating = useAtom(drawer_animation_done)[0];
  const isMobile = useBreak('md_dn')
  const drawer   = useAtom(_drawer)[0] 
  const isDetail = drawer.detail
  const thumbnails = isDetail ? unit.getThumb() : [];
  const images = isDetail ? unit.getImages() : [];
  const unitNo = unit?.data?.Data?.NPV_Projektnr?.Value


  const projectType = getFocus(_bootstrap, "type");
  const today = Boolean(moveindate) ? moveindate : false;

  // Specify Danish as the locale and customize options
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const danishFormattedDate = today ? today : false;

   
  return (
    <Box
      sx={{
        width: "100%",
        height:isMobile?"calc(100% - 53px)": "calc(100% - 157px)",
        backgroundColor: "#ffffff",
        overflowY: "auto",
        scrollbarWidth: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderLeft:`1px solid ${clr?.primary}`,
      }}
    >
        <Scrollbar trackYProps={{
          renderer: (props) => {
            const { elementRef, ...restProps } = props;
            return <span {...restProps} ref={elementRef}
            className="trackY" />;
          },
        }}
        contentProps={{
          renderer: (props) => {
            const { elementRef, ...restProps } = props;
            return <span {...restProps} ref={elementRef} style={{ height: "100%", display: "block" }} className="Content" />;
          },
        }}
        >
      <Box sx={{ display: 'flex', flexDirection: "column", height: "100%", justifyContent: "space-between" }}>
      <div>
        <Box sx={{position:"relative", zIndex:2}}>
        <TopDrawer
          availableDate={danishFormattedDate}
          address={`${address}, ${townAndZipcode}`}
          topicCode={topicCode}
          statusText={status.label}
          statusId={status.id}
          backgroundColor={status.color}
          textColor="#ffffff"
          isRent={isRent}
        />
        </Box>
        <Box sx={{position:"relative",top:"-4px", zIndex:1, background: 'white'}}>
        <Gallery isDetail={isDetail} unitId={unitId} images={images} thumbImg={thumbnails} UnitDrawer width = {isMobile ? ' 100%' : '375px'}  height = {isMobile ? '273px' : '273px'} />

        </Box>
  
        <Buttons unitData={unit?.data} unitId={unitId} address={ (address || townAndZipcode ) ? `${address}, ${townAndZipcode}` : ""} rent={price} highlights={highlights} />

        <OpenHouse />

        <Box sx={{  mt: 3 }}>
            <Highlights items={filterHighlights} />

          <Box
            sx={{
              mt: { md: 3, xs: 2 },
              textAlign: "center",
            }}
          >
            <Price
            availablePris={availablePris}
              label={
                isRent
                  ? `${get(unit.data, "LejelejlighedsText")}`
                  : `${label(unit.data, "Kontantpris")}`
              }
              value={(price) ? price : ""}
            />
          </Box>
          {/* <ReservationButton unit={unit}/> */}
          <NewReservationButton unit={unit}/>
          <DropdownProperties isRent={isRent} groups={filteredProperties} facilitiesForCurrentProject={facilitiesForCurrentProject}/>
          {/* <DrawerCTA unit={unit} /> */}
        </Box>
      </div>
      <PoweredBy clr="#004337"/>
      </Box>
        </Scrollbar>
    </Box>
  );
}

export default UnitDrawer;
